import { Component, OnInit, AfterViewInit, Renderer2, ElementRef} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser'; 
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ApiService } from '../api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';  


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  form: FormGroup;
  public sliders: any[] = [];    

  isOpt:string = 'default';
    enquiryName: any;
    enquiryEmail: any;
    enquiryPhone: any;
    enquiryMessage: any;
    feedbackName: any;
    feedbackEmail: any;
    feedbackOrganization: any;
    feedbackPhone: any;
    feedbackInvoice: any;
    feedbackLot: any;
    feedbackProduct: any;
    feedbackDetails: any;

  constructor(
    private route: Router,
    private apiService: ApiService,
    private titleService: Title,
    private metaService: Meta,
    private renderer: Renderer2,
    private el: ElementRef,
    private httpClient: HttpClient,
    private formBuilder: FormBuilder     

  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("Chartered Transport | Line Haul")

        const metaDesc = this.metaService.getTag('name=description'); 

        if(!metaDesc){
            this.metaService.addTags([
                {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!"}
            ]);
        }else{
            this.metaService.updateTag(  
                {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!" },  
                "name=description"  
            )  
        }

    this.form = this.formBuilder.group({
      enquiryName: ['', Validators.required],
      enquiryAddress: ['', Validators.required],
      enquiryEmail: ['', [Validators.required, Validators.email]],
      enquiryPhone: ['', Validators.required],
      enquiryMessage: ['', Validators.required],
    });

    this.titleService.setTitle("Contact Us | Line Haul")

    this.loadCarousel('contact-us', 'active');       

  }

  loadCarousel(page: string, state: string): void {
    this.apiService.loadCarousel(page, state).subscribe(
        response => {
            this.sliders = response.carousels;
        },
        error => {
            console.error('Error fetching carousel:', error);
        }
    );
  }

  selectedOpt(value:string){

    switch (value) {
        case 'default':
            this.isOpt = 'default'
            break;
        case 'enquiry':
            this.isOpt = 'enquiry'
            break;
        case 'feedback':
            this.isOpt = 'feedback'
            break;
        default:
            break;
    }
  }

  // To handle form submission ---> 
  submitted = false;

  submitForm() {
    this.submitted = true;

    if (this.form.valid) {
      this.sendMail();
    }
  }

  sendMail() 
  {
    if (this.form.valid) {
      const data = {
        name: this.form.value.enquiryName,
        address: this.form.value.enquiryAddress,
        email: this.form.value.enquiryEmail,
        phone: this.form.value.enquiryPhone,
        message: this.form.value.enquiryMessage,
        form_type:"enquiry"
      };

      this.apiService.postSendEmail(data).subscribe(
        (res: any) => {
          console.log('Email sent successfully', res);
          Swal.fire(
            'Sent.',
            'We will contact you later, Thanks!',
            'success'
        )
        },
        error => {
          console.error('Error sending email', error);
        }
      );
    }
  }
  
  public goToFragment(fragment: string): void{

    // let elementId = 'serviceId'
    
    // this.route.navigate( ['/landing#'], {fragment: fragment});
    // this.route.navigate(['/landing#'], { fragment: 'serviceId' });
    // this.route.navigate(['/landing#'+fragment])
    // this.redirectTo('/landing#serviceId');
    // window.location.href = '/v2/landing#' + fragment;
    // window.location.href = '/landing#' + fragment;
    // window.location.href = 'https://lineclearexpress.com/v2/landing#serviceId'
    // window.location.replace("http://someUrl.com");
    // this.viewportScroller.scrollToAnchor(elementId);

    // production
    // this.route.navigateByUrl("/v2/landing#serviceId")

    // staging 
    this.route.navigateByUrl("/#serviceId")
    
  }

  goToAboutUs(){
    this.route.navigate(['about-us']);
  }

  goToOurStrength(){
    this.route.navigate(['our_strength']);
  }

  goToMilestone(){
    this.route.navigate(['milestone']);
  }


  
}

